import { jsx as _jsx } from "react/jsx-runtime";
import { useSideCategoryMenuStore } from "@/components/SideSheets/store/useCategoryMenuStore";
import { cn } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useScrollLock } from "usehooks-ts";
import CategoryMenuDesktop from "./CategoryMenuDesktop";
import CategoryMenuMobile from "./CategoryMenuMobile";
import CategoryMenuTablet from "./CategoryMenuTablet";
const CategoryMenu = ()=>{
    const { isOpenSideMenu  } = useSideCategoryMenuStore();
    const { isDesktop , isTablet  } = useWindowDimensions();
    const [mounted, setMounted] = useState(false);
    // 스크롤 잠금 (중앙에서 한 번만 관리)
    const { lock , unlock  } = useScrollLock({
        autoLock: false
    });
    useEffect(()=>{
        setMounted(true);
    }, []);
    useEffect(()=>{
        if (!mounted) return;
        if (isOpenSideMenu) {
            lock();
        } else {
            unlock();
        }
        return ()=>{
            unlock();
        };
    }, [
        mounted,
        isOpenSideMenu,
        lock,
        unlock
    ]);
    // 클라이언트 마운트 전이면 렌더링하지 않음
    if (!mounted) {
        return null;
    }
    // 브레이크포인트 분기 (항상 렌더링, 내부에서 isOpen으로 visibility 제어)
    // - Desktop: 1200px 이상
    // - Tablet: 744px ~ 1200px
    // - Mobile: 744px 미만
    const getContent = ()=>{
        if (isDesktop) {
            return /*#__PURE__*/ _jsx(CategoryMenuDesktop, {});
        } else if (isTablet) {
            return /*#__PURE__*/ _jsx(CategoryMenuTablet, {});
        }
        return /*#__PURE__*/ _jsx(CategoryMenuMobile, {});
    };
    // Portal을 사용하여 body에 직접 렌더링 (z-index 스택 컨텍스트 문제 방지)
    // 항상 마운트, 닫힌 상태에서는 z-index를 낮춰서 GNB 버튼 cursor 동작 보장
    return /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsx("div", {
        className: cn(!isOpenSideMenu && "pointer-events-none -z-10"),
        children: getContent()
    }), document.body);
};
export default CategoryMenu;
